// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCJn3h5MELpX5UQS3MlWmWVTCgkp_FfDnk",
  authDomain: "imab-auth.firebaseapp.com",
  projectId: "imab-auth",
  storageBucket: "imab-auth.appspot.com",
  messagingSenderId: "96774304840",
  appId: "1:96774304840:web:7189c0a079ba513077547d",
  measurementId: "G-2C5FVQY1M6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);
// Set persistence to LOCAL
setPersistence(auth, browserLocalPersistence);

// Initialize Firestore
const db = getFirestore(app);

// Add this function to help decode tokens
export const decodeToken = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

// Update the refreshUserToken function
const refreshUserToken = async () => {
  const user = auth.currentUser;
  if (user) {
    await user.getIdToken(true); // Force token refresh
    const newToken = await user.getIdToken();
    
    // Verify the token has the required claims
    const decodedToken = decodeToken(newToken);
    if (!decodedToken?.tenant || !decodedToken?.claim) {
      console.warn('Token missing required claims');
    }
    
    return newToken;
  }
  return null;
};

export { auth, refreshUserToken, db };